import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ExtraOptions, PreloadAllModules, RouterModule} from '@angular/router';
import {MarkdownModule} from 'ngx-markdown';
import {CipaFacilModule} from '@cipafacil';
import {CipaFacilConfigModule} from '@cipafacil/services/config';
import {CipaFacilMockApiModule} from '@cipafacil/lib/mock-api';
import {CoreModule} from 'app/core/core.module';
import {appConfig} from 'app/core/config/app.config';
import {mockApiServices} from 'app/mock-api';
import {LayoutModule} from 'app/layout/layout.module';
import {AppComponent} from 'app/app.component';
import {appRoutes} from 'app/app.routing';
import {IonicModule} from '@ionic/angular';
import {NgxHotjarModule, NgxHotjarRouterModule} from 'ngx-hotjar';
import {environment} from '../environments/environment';
import {DatePipe} from '@angular/common';
import {DocumentDirective} from './core/pipes/document';
import {InAppBrowser} from "@awesome-cordova-plugins/in-app-browser/ngx";
import {CustomDatePipe} from "./core/pipes/custom-date";

const routerConfig: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
};

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        NgxHotjarModule.forRoot(environment.hotJarCode),
        NgxHotjarRouterModule,

        // CipaFacil & CipaFacil Mock API
        CipaFacilModule,
        CipaFacilConfigModule.forRoot(appConfig),
        CipaFacilMockApiModule.forRoot(mockApiServices),

        // Core
        CoreModule,

        // Layout
        LayoutModule,

        // 3rd party modules
        MarkdownModule.forRoot({}),

        IonicModule.forRoot()
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        DatePipe,
        CustomDatePipe,
        DocumentDirective,
        InAppBrowser
    ]
})
export class AppModule {
}
